// eslint-disable-next-line import/no-cycle
import { postApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({
		isLoading: false,
		items: {},
		unfinishedPaySum: null,
	}),
	mutations: {
		setHistoryItems(state, val) {
			state.items = val;
		},
		setLoading(state, val) {
			state.isLoading = val;
		},
		setUnfinishedPaySum(state, val) {
			state.unfinishedPaySum = val;
		},
	},
	actions: {
		// eslint-disable-next-line no-empty-pattern
		async getHistoryItemsAction({ commit }, options) {
			try {
				const response = await postApi('/k5/v1/payment/recent-operations', options);
				console.log('getHistoryItemsAction response: ', response);
				if (response.data.status === true && response.data.data?.operations) {
					const list = {};
					response.data.data.operations.forEach((item) => {
						const date = item.date ? item.date : item.paymentGetway_created_at;
						if (list[date.slice(0, 10)]) {
							list[date.slice(0, 10)].push(item);
						} else {
							list[date.slice(0, 10)] = [item];
						}
					});
					commit('setHistoryItems', list);
				}
			} catch (e) {
				console.log(e);
			}
		},
	},
};
